"use client";

import Image from "next/image";

/**
 * Reusable App Features Section
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {Array} props.features - Array of feature objects { title, description, image }
 */
export const AppFeaturesSection = ({
  title = "Designed to convert. Built to scale.",
  features = [],
  glowGradient = "linear-gradient(149.4deg, #EEFFFB 6.54%, #3DEDD0 40.27%, #C17BFF 70.76%)",
}) => {

  return (
    <section className="pt-16 pb-16 relative z-10 overflow-hidden bg-[#1e1e1e]">
      <div className="mx-auto px-6 md:px-16 lg:px-32 relative z-10 max-w-[1440px]">
        {/* Section Title */}
        <div className="flex flex-col items-center max-w-[1280px] mx-auto mb-16">
          <h2
            className="text-3xl md:text-[48px] font-normal text-[#f8f7f4] text-center tracking-[-0.96px] w-full"
            style={{ lineHeight: "56px" }}
          >
            {title}
          </h2>
        </div>

        {/* Features Grid */}
        <div className="flex flex-col md:flex-row flex-wrap gap-6 items-stretch justify-center max-w-[1184px] mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative flex-1 min-w-[280px]"
            >
              {/* Glow behind card on hover */}
              <div
                className="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  width: "350px",
                  height: "300px",
                  borderRadius: "61px",
                  background: glowGradient,
                  transform: "rotate(-45deg)",
                  filter: "blur(150px)",
                  top: "35%",
                  left: "50%",
                  translate: "-50% -50%",
                  zIndex: 0,
                }}
              />

              {/* Card */}
              <div className="relative flex flex-col overflow-hidden rounded-2xl bg-[#1e1e1e] border-2 border-[#2e2e2e] transition-transform duration-500 group-hover:-translate-y-2 h-full">
                {/* Image */}
                <div className="relative w-full h-[288px] shrink-0 border-b border-[#2e2e2e]">
                  {feature.image && (
                    <Image
                      src={feature.image}
                      alt={feature.title}
                      fill
                      sizes="(max-width: 768px) 100vw, (max-width: 1184px) 50vw, 384px"
                      className="object-cover"
                    />
                  )}
                </div>

                {/* Text Content */}
                <div className="px-8 py-8">
                  <p
                    className="text-base tracking-[-0.032px]"
                    style={{ lineHeight: "24px" }}
                  >
                    <span className="font-semibold text-[#f8f7f4]">
                      {feature.title}
                    </span>{" "}
                    <span className="font-normal text-[#c4c4c4]">
                      {feature.description}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
